import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { Badge } from "../ui/badge";

const FAQ_ITEMS = [
  {
    question: "How does voice command work?",
    answer: "Simply speak your marketing goals in any of 12 supported languages. Our AI understands natural language and converts your voice into complete marketing campaigns - including videos, images, and captions - ready to publish."
  },
  {
    question: "What social media platforms are supported?",
    answer: "YASNO currently supports TikTok, Instagram, LinkedIn, Twitter/X, YouTube, and Facebook. We automatically optimize content format and size for each platform."
  },
  {
    question: "Is my data secure?",
    answer: "Absolutely. All content goes through our AI Brand Safety layer before publishing. We are SOC 2 Type II compliant and your data is encrypted at rest and in transit."
  },
  {
    question: "Can I edit AI-generated content?",
    answer: "Yes! You can preview all content in your dashboard, edit if needed, or approve with one click. The AI learns from your preferences over time."
  },
  {
    question: "Do you actually post to social media?",
    answer: "Yes! Once you connect your social accounts and upgrade from the preview, YASNO posts content automatically to all your platforms at optimal times."
  },
  {
    question: "What languages does the AI support?",
    answer: "We support 12 languages for voice commands: English, Arabic, Spanish, Urdu, Chinese, French, German, Portuguese, Japanese, Korean, Hindi, and Russian. Content generation supports 40+ languages."
  }
];

/**
 * FAQSection Component - EXACT ORIGINAL DESIGN
 */
export default function FAQSection() {
  return (
    <section id="faq" className="py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <Badge className="mb-4 bg-primary/20 text-primary border-primary/30">
            FAQ
          </Badge>
          <h2 className="text-3xl sm:text-4xl font-bold mb-4" data-testid="faq-title">
            Frequently Asked Questions
          </h2>
          <p className="text-muted-foreground">
            Everything you need to know about YASNO
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <Accordion type="single" collapsible className="space-y-4">
            {FAQ_ITEMS.map((item, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="glass-card rounded-xl border border-white/10 px-6 data-[state=open]:border-primary/30"
              >
                <AccordionTrigger className="text-left hover:no-underline py-4" data-testid={`faq-${index}`}>
                  <span className="font-medium">{item.question}</span>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-4">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
